<ion-tabs>
  <ion-tab-bar slot="bottom" class="c-tab-bar" [class.c-tab-bar--hide]="!showTab">
    <ion-tab-button *ngFor="let tab of tabs" #tabRef [tab]="tab.name">
      <ion-icon [name]="tab.icon" class="c-tab-bar__icon"></ion-icon>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
